module.exports = __webpack_public_path__ + "img/mas_buscados_1.0f4f9d8a.png";